import React from 'react'

export default function Research(){
  return (
    <main>
      {/* <section className="py-5" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white'}}> */}
      <section className="container-fluid page-banner black-banner" style={{background: 'url(/img/RD.jpeg) center', height: '580px', backgroundSize: 'cover', backgroundPositionY: '54%'}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 text-center text-md-left">
              <h1 className="display-4 mb-4 mb-md-0  font-weight-bold">R&D / Technical</h1>
              <p className="lead mb-0">Advanced Research & Development Services</p>
            </div>
            {/* <div className="col-md-6 text-center text-md-right">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb bg-transparent p-0 m-0 justify-content-center justify-content-md-end">
                  <li className="breadcrumb-item"><a href="/" className="text">Home</a></li>
                  <li className="breadcrumb-item active " aria-current="page">R&D / Technical</li>
                </ol>
              </nav>
            </div> */}
          </div>
        </div>
      </section>
      {/* Services Offered Section */}
      <section className="py-5" style={{backgroundColor: '#f5f5f0'}}>
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-4 font-weight-bold mb-4" style={{color: '#5d4037'}}>Services Offered</h2>
            <p className="lead text-muted">Comprehensive R&D solutions for pharmaceutical excellence</p>
          </div>

          {/* Services - All 4 Side by Side */}
          <div className="container">
            <div className="row align-items-stretch g-3">
              {/* Analytical Research Card */}
              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-lg h-100" style={{minHeight: '320px', backgroundColor: 'white'}}>
                  <div className="card-header text-center py-2" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                    <i className="fas fa-microscope fa-lg mb-1"></i>
                    <h6 className="card-title mb-0 font-weight-bold" style={{fontSize: '1.2rem'}}>Analytical Research</h6>
                  </div>
                  <div className="card-body text-center d-flex flex-column p-2">
                    <div className="service-details">
                      <div className="service-item mb-1">
                        <i className="fas fa-check-circle text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Method Development</span>
                      </div>
                      <div className="service-item mb-0">
                        <i className="fas fa-check-circle text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Method Validation</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Formulation Development Card */}
              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-lg h-100" style={{minHeight: '320px', backgroundColor: 'white'}}>
                  <div className="card-header text-center py-2" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                    <i className="fas fa-flask fa-lg mb-1"></i>
                    <h6 className="card-title mb-0 font-weight-bold" style={{fontSize: '1.0rem'}}>Formulation Development</h6>
                  </div>
                  <div className="card-body text-center d-flex flex-column p-2">
                    <div className="service-details">
                      <div className="service-item mb-1">
                        <i className="fas fa-pills text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Oral Solids</span>
                      </div>
                      <div className="service-item mb-1">
                        <i className="fas fa-tint text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Oral Liquids</span>
                      </div>
                      <div className="service-item mb-1">
                        <i className="fas fa-syringe text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Complex Injectables</span>
                      </div>
                      <div className="service-item mb-1">
                        <i className="fas fa-hand-holding-medical text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Topical Preparations</span>
                      </div>
                      <div className="service-item mb-1">
                        <i className="fas fa-capsules text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Rectal & Vaginal</span>
                      </div>
                      <div className="service-item mb-0">
                        <i className="fas fa-wind text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Inhaled Dry Powders</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contract Manufacturing Card */}
              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-lg h-100" style={{minHeight: '320px', backgroundColor: 'white'}}>
                  <div className="card-header text-center py-2" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                    <i className="fas fa-industry fa-lg mb-1"></i>
                    <h6 className="card-title mb-0 font-weight-bold" style={{fontSize: '1.2rem'}}>Contract Manufacturing</h6>
                  </div>
                  <div className="card-body text-center d-flex flex-column p-2">
                    <div className="service-details">
                      <div className="service-item mb-1">
                        <i className="fas fa-expand-arrows-alt text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Scale-Up</span>
                      </div>
                      <div className="service-item mb-1">
                        <i className="fas fa-flask text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Clinical Trial Batches</span>
                      </div>
                      <div className="service-item mb-0">
                        <i className="fas fa-tools text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Technology Transfer</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contract Testing & Stability Card */}
              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-lg h-100" style={{minHeight: '320px', backgroundColor: 'white'}}>
                  <div className="card-header text-center py-2" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                    <i className="fas fa-chart-line fa-lg mb-1"></i>
                    <h6 className="card-title mb-0 font-weight-bold" style={{fontSize: '1.2rem'}}>Testing & Stability</h6>
                  </div>
                  <div className="card-body text-center d-flex flex-column p-2">
                    <div className="service-details">
                      <div className="service-item mb-1">
                        <i className="fas fa-vial text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Third Party Testing</span>
                      </div>
                      <div className="service-item mb-0">
                        <i className="fas fa-chart-line text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Stability Testing</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          {/* <div className="text-center mt-5">
            <div className="card border-0 shadow-sm" style={{background: 'linear-gradient(135deg, #efebe9 0%, #d7ccc8 50%, #efebe9 100%)'}}>
              <div className="card-body py-4">
                <h4 className="mb-3" style={{color: '#5d4037'}}>Ready to Partner with Us?</h4>
                <p className="mb-4 text-muted">Contact our R&D team to discuss your specific requirements and explore collaboration opportunities.</p>
                <a href="mailto:lakulishpharma@gmail.com" className="btn btn-lg px-4" style={{backgroundColor: '#5d4037', color: 'white', border: 'none'}}>
                  <i className="fas fa-envelope mr-2"></i>Get In Touch
                </a>
              </div>
            </div>
          </div> */}
        </div>
      </section>

      {/* R&D Capabilities Section */}
      <section className="py-5" style={{backgroundColor: '#f5f5f0'}}>
        <div className="container">
          <div className="text-center mb-5">
            <h1 className="mb-4 section-title" style={{color: '#5d4037'}}>R&D Capabilities</h1>
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <p className="lead text-muted text-center mb-5">
                  <i className="fas fa-award text-primary mr-2"></i>
                  <strong>More than 10+ years of experience in product development for regions like
                   USA, Latin America, Europe, Canada, Australia, South Africa and other African countries, Middle East Countries, CIS, Asian countries, ROW & Domestic market.</strong>
                </p>
              </div>
            </div>
          </div>

          {/* R&D Capabilities - All Same Size & Color */}
          <div className="container">
            <div className="row align-items-stretch g-3">
              {/* Technical Support Card */}
              <div className="col-lg-4 col-md-6">
                <div className="card border-0 shadow-lg h-100" style={{minHeight: '300px', backgroundColor: 'white'}}>
                  <div className="card-header text-center py-2" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                    <i className="fas fa-cogs fa-lg mb-1"></i>
                    <h6 className="card-title mb-0 font-weight-bold" style={{fontSize: '1.2rem'}}>Technical Support</h6>
                  </div>
                  <div className="card-body text-center d-flex flex-column p-2">
                    <div className="service-details">
                      <div className="service-item mb-1">
                        <i className="fas fa-chart-trending-up text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Regulatory Guidance</span>
                      </div>
                      <div className="service-item mb-0">
                        <i className="fas fa-rocket text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Rapid Development</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Regulatory Support Card */}
              <div className="col-lg-4 col-md-6">
                <div className="card border-0 shadow-lg h-100" style={{minHeight: '300px', backgroundColor: 'white'}}>
                  <div className="card-header text-center py-2" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                    <i className="fas fa-file-alt fa-lg mb-1"></i>
                    <h6 className="card-title mb-0 font-weight-bold" style={{fontSize: '1.2rem'}}>Regulatory Support</h6>
                  </div>
                  <div className="card-body text-center d-flex flex-column p-2">
                    <div className="service-details">
                      <div className="service-item mb-1">
                        <i className="fas fa-globe-americas text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Global CTD/eCTD</span>
                      </div>
                      <div className="service-item mb-1">
                        <i className="fas fa-map-marked-alt text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Regional ACTD</span>
                      </div>
                      <div className="service-item mb-1">
                        <i className="fas fa-file-medical text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Drug Master Files</span>
                      </div>
                      <div className="service-item mb-1">
                        <i className="fas fa-file-medical text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Country Specific Dossiers</span>
                      </div>
                      <div className="service-item mb-1">
                        <i className="fas fa-file-medical text-primary mr-1"></i>
                        <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Pharmacovigilance</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Documentation Services Card */}
              <div className="col-lg-4 col-md-12">
                <div className="card border-0 shadow-lg h-100" style={{minHeight: '300px', backgroundColor: 'white'}}>
                  <div className="card-header text-center py-2" style={{background: 'linear-gradient(135deg, #8d6e63 0%, #5d4037 100%)', color: 'white', border: 'none'}}>
                    <i className="fas fa-clipboard-list fa-lg mb-1"></i>
                    <h6 className="card-title mb-0 font-weight-bold" style={{fontSize: '1.2rem'}}>Documentation</h6>
                  </div>
                  <div className="card-body text-center d-flex flex-column p-2">
                    <div className="service-details">
                      <div className="row">
                        <div className="col-6">
                          <div className="service-item mb-1">
                            <i className="fas fa-tag text-primary mr-1"></i>
                            <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Labelling</span>
                          </div>
                          {/* <div className="service-item mb-1">
                            <i className="fas fa-gavel text-primary mr-1"></i>
                            <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Legal Apps</span>
                          </div> */}
                          <div className="service-item mb-0">
                            <i className="fas fa-reply text-primary mr-1"></i>
                            <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Post-Approval</span>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="service-item mb-1">
                            <i className="fas fa-redo text-primary mr-1"></i>
                            <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Renewals</span>
                          </div>
                          <div className="service-item mb-1">
                            <i className="fas fa-edit text-primary mr-1"></i>
                            <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Variations</span>
                          </div>
                          {/* <div className="service-item mb-0">
                            <i className="fas fa-file-import text-primary mr-1"></i>
                            <span className="font-weight-bold" style={{fontSize: '1.1rem'}}>Import Licenses</span>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* R&D Images Section */}
      <section className="py-5" style={{backgroundColor: '#f5f5f0'}}>
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-4 font-weight-bold mb-4" style={{color: '#5d4037'}}>Our R&D Research</h2>
          </div>
          <div className="row g-4">
            <div className="col-md-4 text-center">
              <img src="/img/rdImg1.jpg" alt="R&D Facility 1" className="img-fluid rounded shadow mb-3" />
              <p className="text-muted">
                Lakulish Pharmaceuticals is actively engaged in pharmaceutical and nutraceutical research, with a strong focus on formulation development, advanced drug delivery systems, analytical method validation, and regulatory-oriented research.
              </p>
            </div>
            <div className="col-md-4 text-center">
              <img src="/img/rdImg2.jpg" alt="R&D Facility 2" className="img-fluid rounded shadow mb-3" />
              <p className="text-muted">
                Our R&D activities are driven by scientific rigor and aligned with ICH, WHO, and global quality standards, enabling the development of stable, effective, and patient-centric dosage forms. Research work conducted by our team has been published in reputed international peer-reviewed journals, reflecting our commitment to innovation, quality, and evidence-based product development.
              </p>
            </div>
            <div className="col-md-4 text-center">
              <img src="/img/rdImg3.jpg" alt="R&D Facility 3" className="img-fluid rounded shadow mb-3" />
              <p className="text-muted">
                The published studies highlight our expertise in nanotechnology-based drug delivery systems, inhalation formulations, transdermal delivery platforms, and analytical method development, supporting both in-house product development and global contract manufacturing collaborations.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}
